import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchCampoValor'
})
export class SearchCampoValorPipe implements PipeTransform {

  transform(items: any, campo:string, valor:string): any {
    if(!items) return []
    if(valor =='' || campo == '' || valor == undefined) return items
    return items.filter(item=> {
      //console.log("campo:", campo, "valor:", valor, "==", item[campo])
      return item[campo] == valor
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/filters/search-campo-valor.pipe.ts